import type { RunnerLevel, RunnerPlayer } from './runnerTypes';

/**
 * Игрок в зоне модификатора и enter ещё не срабатывал.
 * Детект по `worldS ∈ [fromS, toS)` — зона на всю высоту коридора.
 */
export function shouldEnterRunnerModifierZone(
  level: RunnerLevel,
  player: RunnerPlayer,
): boolean {
  const zone = level.modifierZone;
  if (zone == null || zone.entered) {
    return false;
  }
  return player.worldS >= zone.fromS && player.worldS < zone.toS;
}
